export default "__VITE_ASSET__49bea166__"